import DOMPurify from "dompurify";

const richTextSanitizeConfig = {
    FORBID_ATTR: ["class"],
    FORBID_TAGS: ["button", "input", "label", "select", "textarea"],
};

const forceNewTabLinks = (node: Element) => {
    if (node.tagName === "A") {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
    }
};

// Render-time fix (PF-1163): DOMPurify's default allowlist drops `target`, so we re-apply
// target/rel on every anchor. setAttribute inside the hook bypasses the allowlist, so this
// covers links stored without a target too — no data migration needed. The hook is scoped
// (added/removed per call) so it never leaks into other DOMPurify.sanitize callers.
export const sanitizeRichTextHtml = (value: string): string => {
    DOMPurify.addHook("afterSanitizeAttributes", forceNewTabLinks);
    try {
        return DOMPurify.sanitize(value, richTextSanitizeConfig);
    } finally {
        DOMPurify.removeHook("afterSanitizeAttributes");
    }
};
